import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n/I18nProvider";
import { SectionTitle } from "../i18n/SectionTitle";

function OtherSites() {
  const { t } = useI18n();

  const services = [
    {
      id: "subdomain",
      icon: "🌐",
      titleKey: "otherSites.services.subdomain.title",
      descriptionKey: "otherSites.services.subdomain.description",
      color: "#3b82f6",
     
    },
    {
      id: "ssl",
      icon: "🔒",
      titleKey: "otherSites.services.ssl.title",
      descriptionKey: "otherSites.services.ssl.description",
      color: "#10b981",
      
    },
    {
      id: "wordpress",
      icon: "⚡",
      titleKey: "otherSites.services.wordpress.title",
      descriptionKey: "otherSites.services.wordpress.description",
      color: "#f59e0b",
      
    },
    {
      id: "theme",
      icon: "🎨",
      titleKey: "otherSites.services.theme.title",
      descriptionKey: "otherSites.services.theme.description",
      color: "#8b5cf6",
      
    }
  ];

  const projectCategories = [
   
    {
      id: "industry",
      emoji: "🏭",
      titleKey: "otherSites.categories.industry.title",
      projects: [
        { nameKey: "otherSites.categories.industry.projects.sierra", url: "https://08.agenceproconcept.fr" },
        { nameKey: "otherSites.categories.industry.projects.realEstate", url: "https://09.agenceproconcept.fr" },
        { nameKey: "otherSites.categories.industry.projects.mill", url: "https://10.agenceproconcept.fr" },
        { nameKey: "otherSites.categories.industry.projects.electrician", url: "https://11.agenceproconcept.fr" }
      ]
    },
    
    {
      id: "hotellerie",
      emoji: "🏨",
      titleKey: "otherSites.categories.hotellerie.title",
      projects: [
        { nameKey: "otherSites.categories.hotellerie.projects.astra", url: "https://17.agenceproconcept.fr" }
      ]
    },
    {
      id: "esthetique",
      emoji: "💅",
      titleKey: "otherSites.categories.esthetique.title",
      projects: [
        { nameKey: "otherSites.categories.esthetique.projects.bosaBeauty", url: "https://18.agenceproconcept.fr" },
      ]
    },
    {
      id: "construction",
      emoji: "🏗️",
      titleKey: "otherSites.categories.construction.title",
      projects: [
        { nameKey: "otherSites.categories.construction.projects.buildwall", url: "https://22.agenceproconcept.fr" },
        { nameKey: "otherSites.categories.construction.projects.landing", url: "https://23.agenceproconcept.fr" }
      ]
    },
    {
      id: "magazine",
      emoji: "💖",
      titleKey: "otherSites.categories.magazine.title",
      projects: [
        { nameKey: "otherSites.categories.magazine.projects.cosmics", url: "https://26.agenceproconcept.fr" }
      ]
    },
    {
      id: "avocat",
      emoji: "⚖️",
      titleKey: "otherSites.categories.avocat.title",
      projects: [
        { nameKey: "otherSites.categories.avocat.projects.lawyerZone", url: "https://33.agenceproconcept.fr" }
      ]
    },
 
    {
      id: "psychologie",
      emoji: "🧠",
      titleKey: "otherSites.categories.psychologie.title",
      projects: [
        { nameKey: "otherSites.categories.psychologie.projects.coachify", url: "https://36.agenceproconcept.fr" },
        { nameKey: "otherSites.categories.psychologie.projects.astraTherapy", url: "https://38.agenceproconcept.fr" }
      ]
    },
    
    {
      id: "eshop",
      emoji: "🛒",
      titleKey: "otherSites.categories.eshop.title",
      projects: [
        { nameKey: "otherSites.categories.eshop.projects.oceanwp", url: "https://44.agenceproconcept.fr" }
      ]
    },
    {
      id: "immobilier",
      emoji: "🏠",
      titleKey: "otherSites.categories.immobilier.title",
      projects: [
        { nameKey: "otherSites.categories.immobilier.projects.astraRealEstate", url: "https://m4.agenceproconcept.fr" },
      ]
    }
  ];

  return (
    <div className="other-sites-page">
      <div className="other-sites-section layout_padding">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <div className="other-sites-header">
                <div className="other-sites-header__content">
                  <SectionTitle
                    beforeKey="otherSites.title"
                    afterKey="otherSites.titleAccent"
                    className="other-sites_taital"
                  />
                  <p className="blog_text">{t("otherSites.subtitle")}</p>
                </div>
              </div>
            </div>
          </div>
          
          {/* Service Cards */}
          <div className="other-sites-column">
            {services.map((service, index) => (
              <div 
                key={service.id} 
                className="other-sites-card-column"
                style={{ animationDelay: `${index * 0.2}s` }}
              >
                <div className="other-sites-card-column__header">
                  <div className="other-sites-card-column__number">
                    <span className="other-sites-card-column__number-text">0{index + 1}</span>
                  </div>
                  <div className="other-sites-card-column__icon" style={{ backgroundColor: service.color }}>
                    <span className="other-sites-card-column__icon-emoji">{service.icon}</span>
                  </div>
                </div>
                <div className="other-sites-card-column__content">
                  <h3 className="other-sites-card-column__title">{t(service.titleKey)}</h3>
                  <p className="other-sites-card-column__description">{t(service.descriptionKey)}</p>
                </div>
                <div className="other-sites-card-column__arrow">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M5 12H19M19 12L16 9M19 12L16 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
              </div>
            ))}
          </div>

          {/* Projects by Category */}
          <div className="other-sites-projects">
            <div className="row">
              <div className="col-sm-12">
                <h2 className="other-sites-projects__title">{t("otherSites.projects.title")}</h2>
                <p className="blog_text">{t("otherSites.projects.subtitle")}</p>
              </div>
            </div>
            
            {projectCategories.map((category) => (
              <div key={category.id} className="other-sites-category">
                <div className="row">
                  <div className="col-sm-12">
                    <h3 className="other-sites-category__title">
                      <span className="other-sites-category__emoji">{category.emoji}</span>
                      {t(category.titleKey)}
                    </h3>
                  </div>
                </div>
                
                <div className="other-sites-category__projects">
                  {category.projects.map((project, index) => (
                    <a 
                      key={index}
                      href={project.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="other-sites-project-item"
                    >
                      <div className="other-sites-project-item__content">
                        <h4 className="other-sites-project-item__name">{t(project.nameKey)}</h4>
                        <span className="other-sites-project-item__url">{project.url}</span>
                      </div>
                      <div className="other-sites-project-item__arrow">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <path d="M4 8H12M12 8L9 5M12 8L9 11" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </div>
                    </a>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default OtherSites;
